export default __webpack_public_path__ + "static/15(1)-c9f9aa6e538b41112f489fba5e948626.png";